import * as React from "react";
const SvgFiRrVolumeSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-volume-slash_svg__a)">
      <path
        fill="#062147"
        d="M15.004 20.004v2.812a1 1 0 0 1-1.181.983c-2.999-.55-5.752-2.299-7.554-4.794H5a5.01 5.01 0 0 1-5.001-5.003v-4c0-1.117.361-2.174 1.045-3.058a1.001 1.001 0 0 1 1.582 1.224A2.97 2.97 0 0 0 1.998 10v4.001A3.006 3.006 0 0 0 5 17.003h1.78c.321 0 .622.154.811.414l.3.415a10.14 10.14 0 0 0 5.113 3.703v-1.532a1 1 0 1 1 2 .001m8.703 3.703a.997.997 0 0 1-1.414 0l-22-22A.999.999 0 1 1 1.707.293L6.33 4.916C8.131 2.468 10.855.753 13.822.206a1 1 0 0 1 1.181.983v12.402l1.686 1.686a4.72 4.72 0 0 0 1.31-3.276 4.72 4.72 0 0 0-1.392-3.359.999.999 0 1 1 1.414-1.414 6.7 6.7 0 0 1 1.978 4.773 6.7 6.7 0 0 1-1.896 4.69l1.415 1.415c3.33-3.418 3.304-8.908-.081-12.292A1 1 0 1 1 20.851 4.4c4.164 4.164 4.191 10.922.081 15.12l2.774 2.774a1 1 0 0 1 0 1.414zM7.762 6.348l5.242 5.242V2.468A10.14 10.14 0 0 0 7.89 6.17z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-volume-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrVolumeSlash;
